import intersection from 'lodash/intersection'
import sortBy from 'lodash/sortBy'
import { useMemo } from 'react'

import { InvoiceDiscountMode } from '@features/invoices/enums/invoiceDiscountMode'
import { InvoiceLineColumn } from '@features/invoices/types/invoiceLineColumn'

import { useInvoiceEditorForm } from '../../../../../../..//contexts/invoiceEditorFormContext'
import { useInvoiceVisibleColumns } from '../../../../../../../hooks/useInvoiceVisibleColumns'
import { DISPLAYABLE_INVOICE_LINE_COLUMNS } from '../constants/displayableInvoiceLineColumns'
import { INVOICE_LINE_COLUMNS_ORDER } from '../constants/invoiceLineColumnsOrder'
import { getInvoiceLineColumnWidth } from '../utils/getInvoiceLineColumnWidth'

export const useInvoiceLinesColumns = () => {
  const { visibleColumns } = useInvoiceVisibleColumns()
  const { discountMode } = useInvoiceEditorForm()

  const sortedVisibleColumns: InvoiceLineColumn[] = useMemo(() => {
    const filteredVisibleColumns: InvoiceLineColumn[] = intersection(visibleColumns, DISPLAYABLE_INVOICE_LINE_COLUMNS)
    if (discountMode === InvoiceDiscountMode.ByItem) {
      filteredVisibleColumns.push('discount')
    }

    return sortBy(filteredVisibleColumns, (column) => INVOICE_LINE_COLUMNS_ORDER.indexOf(column))
  }, [discountMode, visibleColumns])

  const columnItemsTemplate = useMemo(
    () => sortedVisibleColumns.map((column) => getInvoiceLineColumnWidth(column)),
    [sortedVisibleColumns],
  )

  return {
    columns: sortedVisibleColumns,
    columnItemsTemplate,
  }
}
